import { makeStyles } from "@material-ui/core";
import { colors } from "../../../../../../../shared/utils";

const useStyles = makeStyles({
  tableWrapper: {
    borderRadius: "19px",
    overflow: "hidden",
    border: `1px solid ${colors.whiteDark}`,
    minWidth: "500px",
    width: "100%",
    boxSizing: "border-box",
    marginBottom: "16px",
  },
  table: {
    tableLayout: "fixed",
    width: "100%",
  },
  headerCell: {
    background: colors.blueLighten,
    color: colors.white,
    fontWeight: 600,
    borderBottom: "none",
  },
  cell: {
    color: colors.greyFont,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  errorCell: {
    color: colors.greyFont,
    wordBreak: "break-word",
  },
});

export default useStyles;
